/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_124fd539{display:inline-block}\n"}]);
export const root = "root_124fd539";